<template>
  <div id="mybill">
    <Breadcrumb></Breadcrumb>

    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <el-form-item label="操作账号：" class="item">
                  <div
                    style="
                      max-height: 200px;
                      overflow-y: auto;
                      float: left;
                      width: calc(100% - 59px);
                    "
                  >
                    <el-input
                      v-if="isExpandUser"
                      style="width: 139px; margin: 0 29px 0 0"
                      v-model="nickName"
                      size="small"
                      placeholder="操作账号"
                    ></el-input>
                    <el-checkbox
                      @change="handleChangeUser"
                      v-model="isCheckUser"
                      >全选</el-checkbox
                    >
                    <el-checkbox-group
                      filterable
                      v-model="form.operNo"
                      placeholder="请选择姓名"
                      class="input"
                      size="small"
                      clearable
                      style="display: inline; margin: 0 0 0 27px"
                      @change="handleChangeOper"
                    >
                      <el-checkbox
                        v-for="(item, index) in userList"
                        :key="index"
                        :label="item.userName"
                        v-show="
                          (isExpandUser || index < 10) &&
                          item.nickName &&
                          item.nickName.indexOf(nickName) > -1
                        "
                      >
                        {{ item.nickName }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div
                    v-if="userList.length > 10"
                    @click="isExpandUser = !isExpandUser"
                    style="
                      margin: 0 0 0 16px;
                      cursor: pointer;
                      color: #409eff;
                      float: left;
                    "
                  >
                    {{ isExpandUser ? "－收起" : "＋展开" }}
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <el-form-item label="店铺名称：" class="item">
                  <div
                    style="
                      max-height: 200px;
                      overflow-y: auto;
                      float: left;
                      width: calc(100% - 59px);
                    "
                  >
                    <el-input
                      v-if="isExpand"
                      style="width: 139px; margin: 0 29px 0 0"
                      v-model="shopName"
                      size="small"
                      placeholder="店铺名称"
                    ></el-input>
                    <el-checkbox
                      @change="handleChangeShop"
                      v-model="isCheckShop"
                      >全选</el-checkbox
                    >
                    <el-checkbox-group
                      filterable
                      v-model="form.shopIds"
                      placeholder="请选择店铺名称"
                      class="input"
                      size="small"
                      clearable
                      style="display: inline; margin: 0 0 0 27px"
                    >
                      <el-checkbox
                        v-for="(item, index) in shopList"
                        :key="index"
                        :label="item.shopId"
                        v-show="
                          (isExpand || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                        "
                      >
                        {{ item.shopName
                        }}<span v-if="item.amazonSite"
                          >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                        >
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div
                    v-if="shopList.length > 10"
                    @click="isExpand = !isExpand"
                    style="
                      margin: 0 0 0 16px;
                      cursor: pointer;
                      color: #409eff;
                      float: left;
                    "
                  >
                    {{ isExpand ? "－收起" : "＋展开" }}
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="统计方式：" prop="statRange">
                <el-radio-group v-model="statRange">
                  <el-radio :label="`date`">日期维度</el-radio
                  ><el-radio :label="`shop`">店铺维度</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="日期类型：" prop="statType">
                <el-radio-group v-model="form.statType">
                  <el-radio
                    v-for="value in dictData['statType']"
                    :key="value.value"
                    :label="value.value"
                    >{{ value.label }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                v-if="form.statType == '1'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  size="small"
                  v-model="dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="form.statType == '2'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="weekBegin"
                  type="week"
                  format="yyyy 第WW周"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="weekEnd"
                  type="week"
                  format="yyyy 第WW周"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="form.statType == '3'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="monthBegin"
                  type="month"
                  format="yyyy 第M月"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="monthEnd"
                  type="month"
                  format="yyyy 第M月"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="form.statType == '5'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="yearBegin"
                  type="year"
                  format="yyyy"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="yearEnd"
                  type="year"
                  format="yyyy"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="平台渠道：" prop="fundType">
                <el-select
                  clearable
                  v-model="form.platNo"
                  placeholder="请选择平台渠道"
                  class="input"
                  style="width: 100%"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['plat_no']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-form-item label="产品类型：" class="item">
                  <el-select
                    v-model="form.productType"
                    placeholder="请选择产品类型"
                    class="input"
                    size="small"
                    clearable
                  >
                    <el-option
                      v-for="(value, index) in dictData['product_type']"
                      :key="index"
                      :label="value.label"
                      :value="value.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="8">
              <el-form-item style="text-align: right" label="" prop="fundType">
                <el-button type="primary" size="small" @click="loadData"
                  >搜索</el-button
                >
                <el-button size="small" @click="resetForm">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <span style="float: left">
          <el-button
            v-if="false"
            type="primary"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table border :data="tableData">
        <el-table-column align="center" label="序号" prop="statDate" width="69">
          <template slot-scope="scope"
            ><span v-if="scope.$index != tableData.length - 1">
              {{ scope.$index + 1 }}
            </span></template
          >
        </el-table-column>
        <el-table-column
          v-if="form.statRange == 'shop'"
          align="center"
          label="店铺"
          prop="shopName"
        >
        </el-table-column>
        <el-table-column
          v-if="form.statRange == 'date'"
          align="center"
          label="日期"
          prop="statCycle"
        >
        </el-table-column>
        <el-table-column align="center" label="订单数" prop="orderNum">
        </el-table-column>
        <el-table-column align="center" label="产品数" prop="orderProNum">
        </el-table-column>
        <el-table-column align="center" label="件数" prop="orderFewNum">
        </el-table-column>
        <el-table-column align="center" label="总销售额" prop="saleTotalNum">
        </el-table-column>
        <el-table-column align="center" label="每件平均销售额" prop="perSale">
        </el-table-column>
        <el-table-column align="center" label="总货款额" prop="payTotalNum">
        </el-table-column>
        <el-table-column align="center" label="每件平均货款额" prop="perPro">
        </el-table-column>
        <el-table-column align="center" label="明细" prop="refundOrderNum">
          <template slot-scope="scope">
            <p v-if="scope.$index != tableData.length - 1">
              <el-button
                type="text"
                size="mini"
                @click="handleShowDetail(scope.row)"
              >
                {{ form.statRange == "shop" ? "日期" : "店铺" }}
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="loadData"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="form.statRange == 'date' ? '店铺明细' : '日期明细'"
      :visible.sync="designVisible"
      destroy-on-close
      width="59%"
    >
      <div style="margin: 0 0 8px 0">
        <span v-if="form.statRange == 'date'"
          >日期： {{ currentRow.statCycle }}</span
        >
        <span v-if="form.statRange == 'shop'"
          >店铺名称： {{ currentRow.shopName }}</span
        >
        <span style="margin: 0 0 0 16px"
          >订单数： {{ currentRow.orderNum }}</span
        >
        <span style="margin: 0 0 0 16px"
          >产品数： {{ currentRow.orderProNum }}</span
        >
        <span style="margin: 0 0 0 16px"
          >件数： {{ currentRow.orderFewNum }}</span
        >

        <span style="margin: 0 0 0 16px" v-if="false"
          >日期：{{ form.beginTime }} ~ {{ form.endTime }}</span
        >
      </div>
      <div>
        <el-table border :data="detailData">
          <el-table-column
            align="center"
            label="序号"
            prop="statDate"
            width="69"
          >
            <template slot-scope="scope"> {{ scope.$index + 1 }} </template>
          </el-table-column>
          <el-table-column
            v-if="form.statRange == 'shop'"
            align="center"
            label="日期"
            prop="statDate"
          >
          </el-table-column>
          <el-table-column
            v-if="form.statRange == 'date'"
            align="center"
            label="店铺"
            prop="shopName"
          >
          </el-table-column>
          <el-table-column align="center" label="订单数" prop="orderNum">
          </el-table-column>
          <el-table-column align="center" label="产品数" prop="orderProNum">
          </el-table-column>
          <el-table-column align="center" label="件数" prop="orderFewNum">
          </el-table-column>
          <el-table-column align="center" label="总销售额" prop="saleTotalNum">
          </el-table-column>
          <el-table-column align="center" label="每件平均销售额" prop="perSale">
          </el-table-column>
          <el-table-column align="center" label="总货款额" prop="payTotalNum">
          </el-table-column>
          <el-table-column align="center" label="每件平均货款额" prop="perPro">
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="designVisible = false" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  selectStatByDate,
  selectStatShopDetail,
  selectStatByShop,
  selectStatDateDetail,
} from "@/api/order/stats"
import { downLoadExcel } from "@/utils/zipdownload"
import qs from "qs"
import { getShopList } from "@/api/system/shopManage"
import { listMainChild } from "@/api/system/user"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 查询参数
      form: {
        pageNum: 1,
        pageSize: 30,
        operNo: [],
        beginTime: undefined,
        endTime: undefined,
        shopIds: [],
        statType: "1",
        statRange: "date",
        productType: "",
        platNo: "",
      },
      dateTime: [],
      weekBegin: "",
      weekEnd: "",
      monthBegin: "",
      monthEnd: "",
      yearBegin: "",
      yearEnd: "",
      loading: false,
      total: 0,
      tableData: [],
      isExpand: false,
      shopName: "",
      isCheckShop: true,
      shopList: [],
      shopListClone: [],
      userList: [],

      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      designVisible: false,
      currentRow: {},
      detailData: [],
      statRange: "date",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.dateTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.weekBegin = this.parseTime(curDate, "{y}-{m}-{d}")
    this.weekEnd = this.parseTime(curDate, "{y}-{m}-{d}")
    this.monthBegin = this.parseTime(curDate, "{y}-{m}-{d}")
    this.monthEnd = this.parseTime(curDate, "{y}-{m}-{d}")

    this.loadData()
    this.getShops()
    this.getUserList()
  },
  methods: {
    loadData() {
      this.startLoading()

      if (this.dateTime && this.form.statType == "1") {
        this.form.beginTime = this.dateTime[0]
        this.form.endTime = this.dateTime[1]
      } else {
        this.form.beginTime = undefined
        this.form.endTime = undefined
      }

      if (this.form.statType == "2") {
        if (!this.weekBegin || !this.weekEnd) {
          this.msgError("请输入统计时间")
          this.endLoading()
          return
        }
        this.form.beginTime = this.getCurrentWeekFirstDay(
          new Date(this.weekBegin)
        )
        this.form.endTime = this.getCurrentWeekLastDay(new Date(this.weekEnd))
      }
      if (this.form.statType == "3") {
        if (!this.monthBegin || !this.monthEnd) {
          this.msgError("请输入统计时间")
          this.endLoading()
          return
        }
        this.form.beginTime = this.getCurrentMonthFirstDay(
          new Date(this.monthBegin)
        )
        this.form.endTime = this.getCurrentMonthLastDay(new Date(this.monthEnd))
      }

      if (!(this.form.beginTime && this.form.endTime)) {
        this.form.beginTime = undefined
        this.form.endTime = undefined
        this.msgError("请输入统计时间")
        this.endLoading()
        return
      }
      this.form.statRange = this.statRange

      let params = Object.assign({}, this.form)
      params.shopIds = params.shopIds.join(",")
      params.operNo = params.operNo.join(",")

      if (params.shopIds == "" && this.isCheckShop) {
        let shopIds = []
        for (let record of this.shopList) {
          shopIds.push(record.shopId)
        }
        params.shopIds = shopIds.join(",")
      }

      let loadMethod =
        params.statRange == "date" ? selectStatByDate : selectStatByShop

      loadMethod(params)
        .then((response) => {
          if (response.rows.length > 0) {
            response.rows[response.rows.length - 1].shopName = "合计"
            response.rows[response.rows.length - 1].statCycle = "合计"
          }
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNo.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNo.includes(record.userName)) {
            if (record.shops) {
              for (let item of record.shops) {
                if (item.shopId == shop.shopId) {
                  return true
                }
              }
            }
          }
        }
        return false
      })
      this.form.shopIds = []
      if (this.form.operNo.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },
    getUserList() {
      listMainChild({}).then((res) => {
        this.userList = res.rows
      })
    },

    async handleShowDetail(row) {
      let loadMethod =
        this.form.statRange == "date"
          ? selectStatShopDetail
          : selectStatDateDetail
      this.currentRow = row

      let params = Object.assign({}, this.form)
      if (params.statType == "1" && params.statRange == "date") {
        params.beginTime = row.statCycle
        params.endTime = row.statCycle
      } else if (params.statType == "1" && params.statRange == "shop") {
        params.beginTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      } else if (params.statType == "2" && params.statRange == "date") {
        if (row.statCycle.indexOf("~") == -1) {
          params.beginTime = row.statCycle
          params.endTime = row.statCycle
        } else {
          params.beginTime = row.statCycle.split("~")[0]
          params.endTime = row.statCycle.split("~")[1]
        }
      } else if (params.statType == "2" && params.statRange == "shop") {
        if (!this.weekBegin || !this.weekEnd) {
          this.msgError("请输入统计时间")
          this.endLoading()
          return
        }
        params.beginTime = this.getCurrentWeekFirstDay(new Date(this.weekBegin))
        params.endTime = this.getCurrentWeekLastDay(new Date(this.weekEnd))
      } else if (params.statType == "3" && params.statRange == "date") {
        if (row.statCycle.indexOf("~") == -1) {
          params.beginTime = row.statCycle
          params.endTime = row.statCycle
        } else {
          params.beginTime = row.statCycle.split("~")[0]
          params.endTime = row.statCycle.split("~")[1]
        }
      } else if (params.statType == "3" && params.statRange == "shop") {
        if (!this.monthBegin || !this.monthEnd) {
          this.msgError("请输入统计时间")
          this.endLoading()
          return
        }
        params.beginTime = this.getCurrentMonthFirstDay(
          new Date(this.monthBegin)
        )
        params.endTime = this.getCurrentMonthLastDay(new Date(this.monthEnd))
      }

      params.shopIds = row.shopId
      delete params["operNo"]

      let result = await loadMethod(params)
      this.detailData = result.rows
      this.designVisible = true
    },

    resetForm() {
      this.form = {
        pageNum: 1,
        pageSize: 10,
        operNo: [],
        beginTime: undefined,
        endTime: undefined,
        shopIds: [],
        statType: "1",
        statRange: "date",
        productType: "",
        platNo: "",
      }
      this.dateTime = []
      this.payTimeBegin = ""
      this.payTimeEnd = ""
      this.monthBegin = ""
      this.monthEnd = ""
      this.yearBegin = ""
      this.yearEnd = ""

      let curDate = new Date()
      let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

      this.dateTime = [
        this.parseTime(preDate, "{y}-{m}-{d}"),
        this.parseTime(curDate, "{y}-{m}-{d}"),
      ]
      this.weekBegin = this.parseTime(curDate, "{y}-{m}-{d}")
      this.weekEnd = this.parseTime(curDate, "{y}-{m}-{d}")
      this.monthBegin = this.parseTime(curDate, "{y}-{m}-{d}")
      this.monthEnd = this.parseTime(curDate, "{y}-{m}-{d}")
    },
    /**导出 */
    handleExport() {
      if (this.form.time) {
        this.form.beginTime = this.form.time[0]
        this.form.endTime = this.form.time[1]
      } else {
        this.form.beginTime = undefined
        this.form.endTime = undefined
      }
      let params = Object.assign({}, this.form)
      delete params["time"]
      delete params["pageSize"]
      delete params["pageNum"]
      downLoadExcel(
        `/money/fund/export?${qs.stringify(this.form)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu")
          this.objectHeight = this.scrollMenu.offsetTop
          window.addEventListener("scroll", this.handleScroll)
        })
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleChangeShop() {
      this.form.shopIds = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopIds.push(record.shopId)
        })
      }
    },
    handleChangeUser() {
      this.form.operNo = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNo.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = []
      }
      this.form.shopIds = []
    },

    /**
     * 获取本周的第一天
     * 返回格式: YYYY-mm-dd
     *    例子: 当日为: 2020-11-27
     *      返回日期为: 2020-11-23
     * */
    getCurrentWeekFirstDay(date) {
      let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
      let firstMonth = Number(weekFirstDay.getMonth()) + 1

      if (firstMonth < 10) {
        firstMonth = "0" + firstMonth
      }
      let weekFirstDays = weekFirstDay.getDate()
      if (weekFirstDays < 10) {
        weekFirstDays = "0" + weekFirstDays
      }
      return weekFirstDay.getFullYear() + "-" + firstMonth + "-" + weekFirstDays
    },
    /**
     * 获取本周的最后一天
     * 返回格式: YYYY-mm-dd
     *    例子: 当日为: 2020-11-27
     *      返回日期为: 2020-11-29
     * */
    getCurrentWeekLastDay(date) {
      let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
      let weekLastDay = new Date((weekFirstDay / 1000 + 6 * 86400) * 1000)
      let lastMonth = Number(weekLastDay.getMonth()) + 1
      if (lastMonth < 10) {
        lastMonth = "0" + lastMonth
      }
      let weekLastDays = weekLastDay.getDate()
      if (weekLastDays < 10) {
        weekLastDays = "0" + weekLastDays
      }
      return weekFirstDay.getFullYear() + "-" + lastMonth + "-" + weekLastDays
    },
    getCurrentMonthFirstDay(date) {
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) {
        month = "0" + month
      }
      if (day < 10) {
        day = "0" + day
      }
      return date.getFullYear() + "-" + month + "-" + day
    },
    getCurrentMonthLastDay(date) {
      let currentMonth = date.getMonth()
      let nextMonth = ++currentMonth
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      let oneDay = 1000 * 60 * 60 * 24
      let lastTime = new Date(nextMonthFirstDay - oneDay)
      let month = parseInt(lastTime.getMonth() + 1)
      let day = lastTime.getDate()
      if (month < 10) {
        month = "0" + month
      }
      if (day < 10) {
        day = "0" + day
      }
      return date.getFullYear() + "-" + month + "-" + day
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
